module.exports = __webpack_public_path__ + "img/apartment.662b6d1e.png";